import { cn } from './cn.js';

/// Atalho discreto para um grupo de marcações: "Marcar tudo" enquanto falta alguma e "Desmarcar
/// tudo" quando o grupo está cheio. Fica ao lado do título do grupo, em texto pequeno, para não
/// disputar atenção com as opções.
///
/// Com menos de duas opções não aparece: marcar tudo de uma é o mesmo clique que marcar ela.
/// `scope` entra só no nome acessível, porque a mesma tela costuma ter vários grupos e o leitor de
/// tela precisa saber qual cada atalho afeta.
export function SelectAllToggle({
  total,
  selected,
  onSelectAll,
  onClear,
  scope,
  disabled = false,
  className,
}: {
  total: number;
  selected: number;
  onSelectAll: () => void;
  onClear: () => void;
  scope: string;
  disabled?: boolean | undefined;
  className?: string | undefined;
}) {
  if (total < 2) return null;
  const full = selected >= total;
  const text = full ? 'Desmarcar tudo' : 'Marcar tudo';

  return (
    <button
      type="button"
      aria-label={`${text} em ${scope}`}
      disabled={disabled}
      onClick={full ? onClear : onSelectAll}
      className={cn(
        'shrink-0 rounded px-1 py-0.5 text-[11px] font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50 disabled:cursor-not-allowed disabled:opacity-50',
        full ? 'text-content-muted hover:text-content' : 'text-brand-400 hover:text-brand-300',
        className,
      )}
    >
      {text}
    </button>
  );
}
